import "./Tasks.css";

import { CompleteTaskModal, WorkflowTaskPanel } from "../../../../../templates/WorkflowTaskPanel";
import { Button, Column, CursorDataGrid, Row, TagFilter } from "../../../../../widget";
import { NewTaskModal } from "../../../components/NewTaskModal";
import { SelectWorkflowTemplateModal } from "../../../components/SelectWorkflowTemplateModal";
import { useDocuments } from "./useTasks";

interface TasksProps {
  type?: "seed" | "default" | undefined;
}

const Tasks = ({ type }: TasksProps): JSX.Element => {
  const {
    columns,
    defaultSortingCriteria,
    dataIsLoading,
    projectDetails,

    showSelectWorkflowTemplateModal,
    setShowSelectWorkflowTemplateModal,

    showWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,
    createTaskIsGeneral,
    showNewTaskModal,
    setShowNewTaskModal,
    handleNewTask,

    showCompleteTaskModal,
    handleCloseCompleteTaskModal,

    selectedCompleteTask,
    selectedPanelTask,

    workflow,
    canCreateTask,
    canCreateGeneralTask,
    canCreateWorkflowTask,
    canApplyWorkflow,

    refreshTasks,
    handleRefresh,

    tagsFilterSelectData,
    tagsFilterValues,
    onTagsFilter,

    navigateToTasksBoard,
    onChange,
  } = useDocuments();

  return (
    <div className="ProjectTabSection">
      <Row spacingV="m">
        <Column span={6}>
          <h2>Tasks</h2>
        </Column>
        <Column span={6}>
          <div className="ProjectTabSectionTasksButtons">
            {projectDetails?.workflowUuid === null ? (
              <>
                {canApplyWorkflow && (
                  <Button
                    text="Apply workflow"
                    variant="tertiary"
                    fontWeight="light"
                    size="small"
                    onClick={() => setShowSelectWorkflowTemplateModal(true)}
                  />
                )}
                {/* No workflow yet, but general tasks are standalone — keep the general-task path open. */}
                {canCreateGeneralTask && (
                  <Button text="New task" fontWeight="light" size="small" onClick={() => setShowNewTaskModal(true)} />
                )}
              </>
            ) : (
              canCreateTask && (
                <>
                  <Button
                    text="View tasks board"
                    variant="tertiary"
                    fontWeight="light"
                    size="small"
                    onClick={navigateToTasksBoard}
                  />
                  <Button text="New task" fontWeight="light" size="small" onClick={() => setShowNewTaskModal(true)} />
                </>
              )
            )}
          </div>
        </Column>
      </Row>
      <div className="ProjectTabSectionTasksFilters">
        <h3>Filter by</h3>
        <TagFilter tags={tagsFilterSelectData} values={tagsFilterValues} onChange={onTagsFilter} />
      </div>
      <CursorDataGrid
        columns={columns}
        clientSide={false}
        filterable
        onChange={onChange}
        data={[]}
        refresh={refreshTasks}
        noDataMessage="No tasks to display"
        dataIsLoading={dataIsLoading}
        defaultSortingCriteria={defaultSortingCriteria}
        variant={type}
      />
      {projectDetails && (
        <SelectWorkflowTemplateModal
          show={showSelectWorkflowTemplateModal}
          closeModal={() => setShowSelectWorkflowTemplateModal(false)}
          projectUuid={projectDetails.uuid}
          projectTypeUuid={projectDetails.projectType.uuid}
        />
      )}
      <NewTaskModal
        show={showNewTaskModal}
        canCreateWorkflowTask={canCreateWorkflowTask}
        canCreateGeneralTask={canCreateGeneralTask}
        onCancel={() => setShowNewTaskModal(false)}
        onConfirm={handleNewTask}
      />
      {selectedCompleteTask && (
        <CompleteTaskModal
          task={selectedCompleteTask}
          show={showCompleteTaskModal}
          closeModal={handleCloseCompleteTaskModal}
          closePanel={handleCloseCompleteTaskModal}
          handleRefresh={handleRefresh}
        />
      )}
      <WorkflowTaskPanel
        task={selectedPanelTask}
        currentStepUuid={selectedPanelTask?.step?.uuid}
        workflow={workflow}
        isGeneralTask={createTaskIsGeneral}
        parentName={projectDetails?.name}
        // Lets a general task be created on a project with no workflow to derive its parent from.
        parentObjectType="Project"
        parentObjectUuid={projectDetails?.uuid}
        show={showWorkflowTaskPanel}
        refresh={refreshTasks}
        handleRefresh={handleRefresh}
        onClose={handleCloseWorkflowTaskPanel}
      />
    </div>
  );
};

export default Tasks;
